/* global google */

import { center } from '../constants/services/map'

export class Map {
  constructor(mapId, mapOps = {
    zoom: 13,
    center,
    disableDefaultUI: true,
  }) {
    this.map = new google.maps.Map(
      document.getElementById(mapId),
      mapOps
    )
  }

  async HttpServiceCroquis(src) {
    const xml = () => {
      return new Promise((res, rej) => {
        var xhttpIcon = new XMLHttpRequest();
        xhttpIcon.onreadystatechange = (resp) => {
          if (xhttpIcon.readyState === 4) {
            if (xhttpIcon.status === 200) {
              // DeletePolysInMap(capaActual);
              var xmlString = xhttpIcon.response;
              var parser = new DOMParser();
              var comunas = parser.parseFromString(xmlString, "text/xml")
              var dataPolys = this.CreateDataForPolygon(comunas, false)
              var polyCapa = this.CreatePolygonLayer(dataPolys, { zIndex: 1, color: 'rgb(0,0,0)', fillOpacity: 0 });    //amarillo
              res(polyCapa)
            }
            else {
              rej(xhttpIcon.responseText);
            }
          }
        };
        xhttpIcon.open("GET", src, true);
        xhttpIcon.send();
      })
    }
    return await xml()
  }

  CreateDataForPolygon(doc, isCroquis = true) {
    let polygons = [];
    var places = doc.getElementsByTagName('Placemark');
    for (let i = 0; i < places.length; i++) {
      var coords = places[i].getElementsByTagName('coordinates');
      for (let j = 0; j < coords.length; j++) {
        polygons.push({
          polygon: this.GetCordsFromPlacemark(coords[j]),
          description: isCroquis ? 'shape' : this.GetDescFromPlacemark(places[i])
        })
      }
    }
    return polygons;
  }

  GetCordsFromPlacemark(coords) {
    var coordsVec = coords.innerHTML.split(" ");
    var resp = [];
    for (let i = 0; i < coordsVec.length; i++) {
      let vec = coordsVec[i].split(',');
      if (!isNaN(Number(vec[1])))
        resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
    }
    return resp
  }

  GetDescFromPlacemark(place) {
    var desc = place.getElementsByTagName('SchemaData')[0].getElementsByTagName('SimpleData');
    var resp = {};
    for (let i = 0; i < desc.length; i++) {
      resp = {
        ...resp,
        [desc[i].getAttribute('name')]: desc[i].innerHTML
      }
    }
    return resp;
  }

  CreatePolygonLayer(data, options = { zIndex: 1, color: '#fff', fillOpacity: '0' }) {
    var polygonsLayer = data.filter(item => {
      return true
    }).map(item => {
      return this.CreatePolygonMap(item.polygon, item.description, options)
    })
    return polygonsLayer
  }

  CreatePolygonMap(coords, description, options) {
    var poly = new google.maps.Polygon({
      paths: coords,
      strokeColor: options.color,
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: options.color,
      fillOpacity: options.fillOpacity,
      zIndex: options.zIndex,
      desc: description
    })
    return poly
  }

  SetPolysInMap(polygon, opt = null) {
    for (let i = 0; i < polygon.length; i++) {
      if (opt !== null) {
        if (polygon[i].desc.MPIO === opt.toString()) {
          polygon[i].setMap(this.map)
        }
      } else {
        polygon[i].setMap(this.map)
      }
    }
  }

  DeletePolysInMap(polygon) {
    try {
      for (let i = 0; i < polygon.length; i++) {
        polygon[i].setMap(null);
      }
    } catch (e) { }
  }

  fitAllMap(polys, ops = null) {
    let bounds = new google.maps.LatLngBounds();
    for (let i = 0; i < polys.length; i++) {
      if (ops !== null) {
        if (polys[i].desc.MPIO === ops.toString()) {
          bounds = this.getBounds(polys[i], bounds)
        }
      } else {
        bounds = this.getBounds(polys[i], bounds)
      }
    }
    this.map.fitBounds(bounds);
  }

  fitBounds(poly) {
    var latLngs = poly.getPath()
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < latLngs.length; i++) {
      bounds.extend(latLngs.getAt(i));
    }
    this.map.fitBounds(bounds);
  }

  createMarker(pos) {
    try { this.marker.setMap(null) } catch (e) { }
    this.marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      title: "Lugar del hecho",
      icon: 'https://siscmura-recursos.s3-us-west-1.amazonaws.com/mapIcons/homicidios.png'
    });
  }

  deleteMarker() {
    this.marker.setMap(null)
  }

  getBounds(poly, bounds) {
    var latLngs = poly.getPath()
    for (var i = 0; i < latLngs.length; i++) {
      bounds.extend(latLngs.getAt(i));
    }
    return bounds
  }

  setCenter(center) {
    this.map.setCenter(center)
  }

  setZoom(zoom) {
    this.map.setZoom(zoom)
  }


}


